const initialState = {
  loading: false,
  collectionResaleList: null,
  subCollectionResaleList: null,
  collectionResaleDetails: null,
  error: null,
};

export const collectionResaleReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_COLLECTION_RESALE_LIST_REQUEST":
    case "GET_SUB_COLLECTION_RESALE_LIST_REQUEST":
    case "ADD_COLLECTION_RESALE_REQUEST":
    case "ADD_SUB_COLLECTION_RESALE_REQUEST":
    case "EDIT_COLLECTION_RESALE_REQUEST":
    case "VIEW_COLLECTION_RESALE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_COLLECTION_RESALE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        collectionResaleList: action.payload,
      };

    case "GET_SUB_COLLECTION_RESALE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        subCollectionResaleList: action.payload,
      };

    case "ADD_COLLECTION_RESALE_SUCCESS":
    case "ADD_SUB_COLLECTION_RESALE_SUCCESS":
    case "EDIT_COLLECTION_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        collectionResaleAction: action.payload,
      };

    case "VIEW_COLLECTION_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        collectionResaleDetails: action.payload,
      };

    case "GET_COLLECTION_RESALE_LIST_FAILED":
    case "GET_SUB_COLLECTION_RESALE_LIST_FAILED":
    case "ADD_COLLECTION_RESALE_FAILED":
    case "ADD_SUB_COLLECTION_RESALE_FAILED":
    case "EDIT_COLLECTION_RESALE_FAILED":
    case "VIEW_COLLECTION_RESALE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};